export default __webpack_public_path__ + "static/adam-c80c8ef9bd3cee257b30f63c07656a47.png";